import UserActivities from './UserActivities'

export default UserActivities
